(() => {
    const pending = new Set();
    const draftFields = (card) => Array.from(card.querySelectorAll('form[data-arrival-receipt-line] input:not([type="hidden"]):not([type="submit"]):not([type="button"]), form[data-arrival-receipt-line] textarea, form[data-arrival-receipt-line] select'));

    function showError(form, text) {
        const message = document.createElement('div');
        message.className = 'alert alert-danger mt-2 mb-0';
        message.dataset.arrivalReceiptRequestError = '';
        message.setAttribute('role', 'alert');
        message.textContent = text;
        form.appendChild(message);
    }

    function replaceLine(line, options = {}) {
        if (!line || !/^\d+$/.test(String(line.id)) || typeof line.html !== 'string' || /<!doctype|<html[\s>]|<head[\s>]|<body[\s>]/i.test(line.html) || (options.expectedId && String(line.id) !== String(options.expectedId))) {
            throw new Error('Invalid arrivalReceipt line response');
        }
        const id = `arrival-receipt-line-${line.id}`;
        const current = document.getElementById(id);
        const template = document.createElement('template');
        template.innerHTML = line.html.trim();
        const replacement = template.content.firstElementChild;
        if (!current || template.content.childElementCount !== 1 || !replacement.matches(`article#${id}`) || replacement.querySelector('article, script, html, body') || Array.from(template.content.childNodes).some(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim())) {
            throw new Error('Invalid arrivalReceipt line HTML');
        }
        const active = document.activeElement;
        const focusedName = current.contains(active) ? active.name : null;
        if (options.preserveDraft) {
            const fields = draftFields(replacement);
            draftFields(current).forEach(field => {
                const next = fields.find(candidate => candidate.name === field.name && candidate.type === field.type);
                if (!next) return;
                if (field.type === 'checkbox' || field.type === 'radio') next.checked = field.checked;
                else next.value = field.value;
            });
        }
        const x = window.scrollX;
        const y = window.scrollY;
        current.replaceWith(replacement);
        const focus = options.focusQuantity ? replacement.querySelector('[data-arrival-receipt-quantity]') : focusedName ? draftFields(replacement).find(field => field.name === focusedName) : null;
        if (focus && !focus.disabled) focus.focus({preventScroll: true});
        window.scrollTo(x, y);
        return replacement;
    }

    window.FullioArrivalReceipt = {replaceLine};

    const finishConfirmed = new WeakSet();
    document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-arrival-receipt-close]') || event.defaultPrevented) return;
        if (pending.size || window.FullioArrivalReceipt.modalSavingLineId) {
            event.preventDefault();
            window.alert('Дождитесь сохранения изменений в приёмке.');
            return;
        }
        if (!event.submitter?.matches('[data-arrival-receipt-finish]')) return;
        if (finishConfirmed.delete(form)) return;
        const hasChanges = Array.from(document.querySelectorAll('article[data-receipt-accepted][data-receipt-damaged]')).some(card => Number(card.dataset.receiptAccepted) !== 0 || Number(card.dataset.receiptDamaged) !== 0);
        if (!hasChanges && !(Number(form.dataset.previouslyReceived) > 0)) {
            event.preventDefault();
            window.alert('Нельзя закрыть поставку: в ней ещё нет принятых товаров.');
            return;
        }
        event.preventDefault();
        const submitter = event.submitter;
        const text = hasChanges ? 'Закрыть поставку? Принятый товар поступит на остаток.' : 'В этой приёмке вы не внесли изменений. Закрыть поставку по ранее принятым товарам?';
        window.dvModal.confirm(text, {button: 'Закрыть поставку'}).then(confirmed => {
            if (!confirmed) return;
            window.dvModal.hide();
            finishConfirmed.add(form);
            form.requestSubmit(submitter);
        });
    });

    // A modal request must not race an acceptance already being saved in this card.
    document.addEventListener('click', (event) => {
        const trigger = event.target instanceof Element ? event.target.closest('[data-dv-toggle="modal"]') : null;
        const card = trigger?.closest('article[id^="arrival-receipt-line-"]');
        if (card && pending.has(card.id)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);

    document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-arrival-receipt-line]') || event.defaultPrevented) return;
        event.preventDefault();
        const card = form.closest('article[id^="arrival-receipt-line-"]');
        if (!card || pending.has(card.id) || window.FullioArrivalReceipt.modalSavingLineId === card.id.replace('arrival-receipt-line-', '') || !form.reportValidity()) return;
        const submit = event.submitter || form.querySelector('[type="submit"]');
        if (submit?.disabled) return;
        const quantity = form.querySelector('[data-arrival-receipt-quantity]');
        if (!quantity || quantity.value.trim() === '') return;
        const entered = Number(quantity.value);
        if (!Number.isInteger(entered)) return;
        const data = new FormData(form);
        if (submit?.name) data.append(submit.name, submit.value);
        pending.add(card.id);
        const controls = Array.from(form.elements).filter(control => control.matches('input:not([type="hidden"]), textarea, select, button'));
        const disabledStates = controls.map(control => [control, control.disabled]);
        controls.forEach(control => { control.disabled = true; });
        card.querySelector('[data-arrival-receipt-request-error]')?.remove();
        try {
            const response = await fetch(form.action, {
                method: form.method.toUpperCase(),
                body: data,
                headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
                redirect: 'error'
            });
            if ((!response.ok && response.status !== 422) || !response.headers.get('content-type')?.includes('application/json')) throw new Error('Unexpected response');
            const payload = await response.json();
            if (response.status === 422 && payload.result === 'error' && payload.saved === false && typeof payload.message === 'string' && payload.message.trim()) {
                showError(form, payload.message);
                return;
            }
            if (payload.result !== 'arrival-receipt-line' || payload.saved !== response.ok) throw new Error('Unexpected arrivalReceipt result');
            replaceLine(payload.arrival_receipt_line, {expectedId: card.id.replace('arrival-receipt-line-', ''), preserveDraft: !payload.saved, focusQuantity: payload.saved});
        } catch (error) {
            showError(form, 'Не удалось получить результат сохранения. Введённые данные сохранены. Проверьте соединение и состояние приёмки перед повторной попыткой.');
        } finally {
            pending.delete(card.id);
            disabledStates.forEach(([control, disabled]) => {
                if (control.isConnected) control.disabled = disabled;
            });
        }
    });
})();
